import { render, staticRenderFns } from "./building-solo.vue?vue&type=template&id=6834fa58&"
import script from "./building-solo.vue?vue&type=script&lang=js&"
export * from "./building-solo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6834fa58')) {
      api.createRecord('6834fa58', component.options)
    } else {
      api.reload('6834fa58', component.options)
    }
    module.hot.accept("./building-solo.vue?vue&type=template&id=6834fa58&", function () {
      api.rerender('6834fa58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/building-solo.vue"
export default component.exports